import { render, staticRenderFns } from "./testData.vue?vue&type=template&id=727b9616&scoped=true&"
import script from "./testData.vue?vue&type=script&lang=js&"
export * from "./testData.vue?vue&type=script&lang=js&"
import style0 from "./testData.vue?vue&type=style&index=0&id=727b9616&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727b9616",
  null
  
)

export default component.exports